import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';

export function PageSectionContainer({
  className,
  // This option removes any right space but keeps the left padding
  rightAlign,
  disableMarginY = false,
  children,
  testid,
}: {
  className?: string;
  disableMarginY?: boolean;
  rightAlign?: boolean;
  children: React.ReactNode;
  testid?: string;
}) {
  const styles = twMerge(
    clsx(
      'w-full',
      !disableMarginY && 'my-[30px] md:my-[45px]',
      rightAlign
        ? 'pl-5 xl:pl-[97px] 3xl:pl-[calc((100vw_-_1728px)_/_2_+_97px)]'
        : 'px-5 xl:px-[97px] max-w-[1728px] mx-auto',
      className,
    ),
  );

  return (
    <div data-testid={testid} className={styles}>
      {children}
    </div>
  );
}
